























































import { Component, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import { GapDateFilter } from "@/store/modules/types";
import DatePicker from "vuejs-datepicker";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class CreatedFilter extends Vue {
  id = "created-filter-popover";
  target = "created-filter-target";
  filter = this.defaultFilter();
  defaultFilter(): GapDateFilter {
    return {
      from: null,
      to: null,
    };
  }
  search() {
    const filter = { ...this.filter };
    this.$store.commit("gaps/SET_CREATED_FILTER", filter);
    this.close();
  }
  clear() {
    this.filter = this.defaultFilter();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { created } = this.$store.state.gaps.filter;
    this.filter = JSON.parse(JSON.stringify(created));
  }
}
